import React from 'react'
import Manager from '../../public/components/Manager'
import EvaluateItemDiv from './EvaluateItemDiv'
import AddEvaluateItemDiv from './AddEvaluateItemDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        {
            icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
                Tyan.pubForm.showDialog('评价项目', props => <AddEvaluateItemDiv {...props} id={0} onSave={refreshPage} showDetail={showDetail} />)
        },
    ],
    columns: [
        { _text: '评价项目名称', field: 'Name', search: true, flex: 1, locked: false },
    ],
    onDoubleTap: ({ showDetail }, data) => showDetail(props => <EvaluateItemDiv {...props} id={data.id} />),
}

export default props => <Manager {...props} config={config} />